import { createSlice } from '@reduxjs/toolkit';
import { fetchProductsList } from './productsThunks';

const productsSlice = createSlice({
  name: 'products',
  initialState: {
    productsList: null,
    loading: false,
    error: null,
  },
  reducers: {
    // Add any synchronous reducers if needed
   
   
  },
  extraReducers: (builder) => {
    builder
      // Handle fetchSalesList
      .addCase(fetchProductsList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductsList.fulfilled, (state, action) => {
        state.loading = false;
        state.productsList = action.payload;
      })
      .addCase(fetchProductsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
     
  },
});

export default productsSlice.reducer;
